import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import ScoringCategoryRowComponent from "./ScoringCategoryRowComponent";
import { BoldCell } from "components/common/TableStyles";

const ScoringCategoryListComponent = ({ onPropertyItemChange, categoryList, categoryOptions, disabled }) => {
  const { t } = useTranslation();

  const handlePropertyItemChange = useCallback(
    idx => (prop, value) => {
      onPropertyItemChange(idx, prop, value);
    },
    [onPropertyItemChange]
  );

  return (
    <Table>
      <TableHead>
        <TableRow>
          <BoldCell>{t("Scoring.ScoringCategory.Criterion")}</BoldCell>
          <BoldCell>{t("Scoring.ScoringCategory.Value")}</BoldCell>
          <BoldCell>{t("Scoring.ScoringCategory.Option")}</BoldCell>
          <BoldCell align="right">{t("Scoring.ScoringCategory.Score")}</BoldCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {categoryList.map((x, idx) => {
          return (
            <ScoringCategoryRowComponent
              key={idx}
              category={x.document}
              onPropertyChange={handlePropertyItemChange(idx)}
              options={categoryOptions.filter(a => a.scoringCategoryId === x.document.scoringCategoryId)}
              validationInfo={x.validationInfo || {}}
              disabled={disabled}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};

ScoringCategoryListComponent.propTypes = {
  onPropertyItemChange: PropTypes.func.isRequired,
  categoryList: PropTypes.array.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  disabled: PropTypes.bool
};

export default memo(ScoringCategoryListComponent);
